import type { Icon } from '@awork/_shared/static-data/icons'
import type { IconNode } from 'lucide'
import {
  BadgeCheck,
  Plus,
  Pencil,
  CopyPlus,
  Link,
  Trash2,
  Ellipsis,
  EllipsisVertical,
  ExternalLink,
  LayoutList,
  ArrowDownWideNarrow,
  ArrowDownNarrowWide,
  ArrowRight,
  ArrowLeft,
  ArrowUpNarrowWide,
  ArrowUpWideNarrow,
  ArrowUpZA,
  ArrowDownZA,
  ArrowUp01,
  ArrowDown,
  ArrowUp,
  Filter,
  Search,
  Star,
  Bell,
  BellRing,
  BellOff,
  Download,
  Share,
  Eye,
  EyeOff,
  ChevronRight,
  ChevronsDown,
  ChevronsUpDown,
  Archive,
  Settings2,
  CalendarFold,
  CalendarCog,
  Calendar1,
  Columns3,
  Settings,
  CalendarClock,
  Tag,
  Hash,
  Flag,
  Goal,
  UserRound,
  NotebookText,
  Newspaper,
  ListChecks,
  Paperclip,
  FileClock,
  PencilRuler,
  Folder,
  FolderCheck,
  FolderOpen,
  ListTodo,
  ListTree,
  GitCompareArrows,
  Repeat,
  SwatchBook,
  Watch,
  UsersRound,
  Building2,
  PiggyBank,
  Milestone,
  Tally5,
  Palette,
  CircleCheck,
  UserRoundPlus,
  LockKeyhole,
  LockKeyholeOpen,
  Files,
  Trello,
  ChartBarBig,
  Table,
  Play,
  Square,
  Pause,
  Timer,
  Receipt,
  SquareCheck,
  CalendarDays,
  Clock9,
  Coffee,
  CopyCheck,
  CirclePlus,
  SmilePlus,
  Sparkle,
  Sparkles,
  AtSign,
  Ban,
  Bot,
  Phone,
  MessageCircle,
  MessageCircleMore,
  Check,
  ChevronLeft,
  X,
  FileText,
  GripVertical,
  CircleAlert,
  Calendar,
  ChevronDown,
  FolderHeart,
  UserPlus,
  History,
  Info,
  ChartColumn,
  Lock,
  RefreshCw,
  Loader,
  Mail,
  MailOpen,
  CalendarArrowDown,
  CalendarArrowUp,
  Clock,
  Users,
  ZoomIn,
  ZoomOut,
  Maximize2,
  ChevronUp,
  Sun,
  Moon,
  PanelLeftClose,
  PanelLeftOpen,
  PanelRightClose,
  PanelRightOpen,
  Plane,
  ToggleLeft,
  KeyRound,
  Puzzle,
  FolderInput,
  ShoppingCart,
  House,
  Rocket,
  Route,
  PanelsRightBottom,
  PanelsTopLeft,
  Inbox,
  Fingerprint,
  LayoutTemplate,
  ImagePlus,
  Calculator,
  CircleX,
  CircleStop,
  MessageSquare,
  MessageSquareText,
  Cloud,
  CloudDownload,
  Code,
  CreditCard,
  SquareCode,
  LayoutDashboard,
  CheckCheck,
  FileOutput,
  Blocks,
  ListOrdered,
  PaintRoller,
  Quote,
  MessagesSquare,
  CircleHelp,
  Image,
  ImageDown,
  Building,
  CircleArrowRight,
  CalendarX,
  Rss,
  Type,
  List,
  Heading1,
  Heading2,
  Heading3,
  UserX,
  PawPrint,
  PieChart,
  CirclePlay,
  User,
  FolderKanban,
  Kanban,
  SquareKanban,
  Globe,
  Minus,
  CircleMinus,
  GripHorizontal,
  RotateCcw,
  TriangleAlert,
  Utensils,
  MessageSquareQuote,
  GraduationCap,
  Scroll,
  Send,
  Signal,
  SignalHigh,
  SignalLow,
  SignalMedium,
  SignalZero,
  Smile,
  ChartLine,
  Presentation,
  Video,
  MonitorPlay,
  ArrowUpDown,
  ArrowUpAZ,
  SpellCheck,
  Database,
  CornerDownLeft,
  CornerDownRight,
  LifeBuoy,
  ArrowLeftRight,
  StickyNote,
  LogIn,
  LogOut,
  Lightbulb,
  CalendarPlus,
  ClockPlus,
  BookOpen,
  BookOpenText,
  Map,
  FolderPlus,
  AlarmClock,
  ArrowDownToLine,
  Banknote,
  Baseline,
  Brain,
  BrainCog,
  Bold,
  Briefcase,
  ChartBar,
  ClipboardList,
  ClipboardCheck,
  Cog,
  Circle,
  ContactRound,
  Copy,
  Factory,
  FileImage,
  FileInput,
  Gift,
  Handshake,
  Headset,
  HeartPulse,
  Italic,
  Layers,
  LayoutGrid,
  Menu,
  Monitor,
  MonitorCog,
  Network,
  Origami,
  PenTool,
  Pointer,
  Scale,
  Save,
  ShoppingBag,
  SquareCheckBig,
  Strikethrough,
  TableOfContents,
  TextAlignStart,
  TextWrap,
  Tv,
  Underline,
  Undo2,
  Redo2,
  Upload,
  UserSearch,
  Wrench,
  Landmark,
  SquareUser,
  SlidersHorizontal,
  Infinity as InfinityIcon,
  Megaphone,
  IdCard,
  Camera,
  Award,
  WandSparkles,
  Zap,
  Clock3,
  Bookmark,
  Paintbrush,
  Bug,
  BriefcaseBusiness,
  Cake,
  Volume2,
  Gamepad2,
  PartyPopper,
  Armchair,
  Minimize2,
  Construction,
  ClipboardPaste,
  FormInput,
  Smartphone,
  PencilLine,
  Leaf,
  Siren,
  Trophy,
  ChartNoAxesColumn,
  Compass,
  Heart,
  PlaneTakeoff,
  Hand,
  Sigma,
  Grid3x3,
  Headphones,
  HeartHandshake,
  FileDown,
  Keyboard,
  Languages,
  Laptop,
  ChartBarStacked,
  ChartGantt,
  Library,
  Wine,
  Beer,
  Flame,
  Flower2,
  Film,
  Clapperboard,
  Pizza,
  Shield,
  ShieldUser,
  Printer,
  Truck,
  Sandwich,
  Recycle,
  ScanEye,
  ScanSearch,
  FlaskConical,
  Store,
  Theater,
  ThumbsUp,
  ToggleRight,
  TrendingUp,
  PinOff,
  Pin,
  PanelRight,
  PanelRightDashed,
  RulerDimensionLine,
  HandHeart,
  Droplets,
  Webhook,
  Sofa,
  Dices,
  MapPin,
  ShieldCheck,
  ChartNoAxesCombined,
  CircleOff,
  Link2Off,
  BanknoteX,
  UserMinus,
  ArchiveRestore,
  CalendarCheck,
  Maximize,
  Hourglass,
  ALargeSmall,
  AArrowDown,
  ChevronsRight,
  SkipForward,
  FastForward,
  Music,
  WifiOff,
  Navigation as NavigationIcon,
  PictureInPicture2,
  Power,
  Mic,
  MousePointerClick,
  MoveRight,
  SquareMinus,
  SquarePlus,
  MailWarning,
  Sheet,
  Slack,
  UserLock,
  TextCursorInput
} from 'lucide'
import {
  AiAgent,
  Astroid,
  AworkBot,
  BellFilledAlt,
  Billed,
  Budget,
  BellRingFilled,
  CalendarSchedule,
  Connect,
  CopyMarkdown,
  DoneShow,
  DownloadPdf,
  DownloadSpreadsheet,
  FileExport,
  FileImportMarkdown,
  FlagFilled,
  FlagFilledAlt,
  HeartFilled,
  MenuMini,
  MenuOpen,
  NotBilled,
  PauseFilled,
  PlannedEffort,
  PlayFilled,
  Popout,
  PopoutCenter,
  RemoveColumn,
  RemoveRow,
  Sso,
  StarFilled,
  StarFilledAlt,
  SquareArrowRightEnter,
  StopFilled,
  TableExport,
  FileMic
} from './custom-icons'

export type LucideIcon =
  | 'plus'
  | 'a-arrow-down'
  | 'agent'
  | 'astroid'
  | 'brain-cog'
  | 'pencil'
  | 'copy-plus'
  | 'link'
  | 'trash-2'
  | 'ellipsis'
  | 'ellipsis-vertical'
  | 'external-link'
  | 'layout-list'
  | 'arrow-down-wide-narrow'
  | 'arrow-down-narrow-wide'
  | 'arrow-right'
  | 'arrow-left'
  | 'arrow-up-narrow-wide'
  | 'arrow-up-wide-narrow'
  | 'arrow-up-z-a'
  | 'arrow-down-z-a'
  | 'arrow-up-0-1'
  | 'arrow-down'
  | 'arrow-up'
  | 'filter'
  | 'search'
  | 'star'
  | 'bell'
  | 'bell-ring'
  | 'bell-off'
  | 'download'
  | 'share'
  | 'eye'
  | 'eye-off'
  | 'chevron-right'
  | 'chevrons-down'
  | 'chevrons-up-down'
  | 'archive'
  | 'settings-2'
  | 'calendar-fold'
  | 'calendar-cog'
  | 'calendar-1'
  | 'columns-3'
  | 'settings'
  | 'calendar-clock'
  | 'tag'
  | 'hash'
  | 'flag'
  | 'goal'
  | 'user-round'
  | 'notebook-text'
  | 'clipboard-list'
  | 'list-checks'
  | 'paperclip'
  | 'file-clock'
  | 'pencil-ruler'
  | 'folder'
  | 'folder-check'
  | 'folder-open'
  | 'list-todo'
  | 'list-tree'
  | 'git-compare-arrows'
  | 'repeat'
  | 'swatch-book'
  | 'watch'
  | 'users-round'
  | 'building-2'
  | 'piggy-bank'
  | 'milestone'
  | 'tally-5'
  | 'palette'
  | 'badge-check'
  | 'circle-check'
  | 'user-round-plus'
  | 'lock-keyhole'
  | 'lock-keyhole-open'
  | 'files'
  | 'trello'
  | 'chart-bar-big'
  | 'table'
  | 'play'
  | 'square'
  | 'pause'
  | 'timer'
  | 'receipt'
  | 'receipt_long'
  | 'square-check'
  | 'calendar-days'
  | 'clock-9'
  | 'clock-3'
  | 'coffee'
  | 'copy-check'
  | 'circle-plus'
  | 'smile-plus'
  | 'sparkle'
  | 'sparkles'
  | 'at-sign'
  | 'ban'
  | 'bot'
  | 'awork'
  | 'phone'
  | 'message-circle'
  | 'message-circle-more'
  | 'check'
  | 'chevron-left'
  | 'x'
  | 'file-text'
  | 'grip-vertical'
  | 'circle-alert'
  | 'calendar'
  | 'chevron-down'
  | 'folder-heart'
  | 'user-plus'
  | 'history'
  | 'info'
  | 'chart-column'
  | 'lock'
  | 'refresh-cw'
  | 'mail'
  | 'mail-open'
  | 'calendar-arrow-down'
  | 'calendar-arrow-up'
  | 'clock'
  | 'users'
  | 'zoom-in'
  | 'zoom-out'
  | 'maximize-2'
  | 'sun'
  | 'moon'
  | 'panel-left-close'
  | 'panel-left-open'
  | 'panel-right-close'
  | 'panel-right-open'
  | 'plane'
  | 'toggle-left'
  | 'key-round'
  | 'puzzle'
  | 'folder-input'
  | 'shopping-cart'
  | 'house'
  | 'route'
  | 'panels-right-bottom'
  | 'panels-top-left'
  | 'inbox'
  | 'fingerprint'
  | 'layout-template'
  | 'image-plus'
  | 'calculator'
  | 'circle-x'
  | 'circle-stop'
  | 'message-square'
  | 'message-square-text'
  | 'cloud'
  | 'cloud-download'
  | 'code'
  | 'square-code'
  | 'layout-dashboard'
  | 'check-check'
  | 'file-output'
  | 'blocks'
  | 'list-ordered'
  | 'paint-roller'
  | 'quote'
  | 'messages-square'
  | 'circle-help'
  | 'image'
  | 'image-down'
  | 'building'
  | 'circle-arrow-right'
  | 'calendar-x'
  | 'rss'
  | 'type'
  | 'list'
  | 'heading-1'
  | 'heading-2'
  | 'heading-3'
  | 'user-x'
  | 'paw-print'
  | 'pie-chart'
  | 'circle-play'
  | 'user'
  | 'folder-kanban'
  | 'kanban'
  | 'square-kanban'
  | 'globe'
  | 'minus'
  | 'circle-minus'
  | 'grip-horizontal'
  | 'rotate-ccw'
  | 'triangle-alert'
  | 'utensils'
  | 'message-square-quote'
  | 'graduation-cap'
  | 'send'
  | 'signal'
  | 'signal-high'
  | 'signal-low'
  | 'signal-medium'
  | 'signal-zero'
  | 'smile'
  | 'chart-line'
  | 'presentation'
  | 'video'
  | 'monitor-play'
  | 'arrow-up-down'
  | 'arrow-up-a-z'
  | 'spell-check'
  | 'database'
  | 'corner-down-left'
  | 'corner-down-right'
  | 'life-buoy'
  | 'arrow-left-right'
  | 'sticky-note'
  | 'loader'
  | 'log-in'
  | 'log-out'
  | 'lightbulb'
  | 'calendar-plus'
  | 'clock-plus'
  | 'book-open'
  | 'book-open-text'
  | 'map'
  | 'folder-plus'
  | 'chevron-up'
  | 'alarm-clock'
  | 'arrow-down-to-line'
  | 'baseline'
  | 'banknote'
  | 'bold'
  | 'brain'
  | 'briefcase'
  | 'chart-bar'
  | 'clipboard-check'
  | 'cog'
  | 'circle'
  | 'contact-round'
  | 'copy'
  | 'copy-markdown'
  | 'factory'
  | 'file-image'
  | 'file-input'
  | 'file-import-markdown'
  | 'gift'
  | 'handshake'
  | 'headset'
  | 'heart-pulse'
  | 'italic'
  | 'layers'
  | 'layout-grid'
  | 'menu'
  | 'monitor'
  | 'monitor-cog'
  | 'network'
  | 'newspaper'
  | 'origami'
  | 'pen-tool'
  | 'pointer'
  | 'scale'
  | 'save'
  | 'shopping-bag'
  | 'square-check-big'
  | 'square-minus'
  | 'strikethrough'
  | 'table-of-contents'
  | 'text-align-start'
  | 'tv'
  | 'underline'
  | 'undo-2'
  | 'upload'
  | 'user-search'
  | 'user-lock'
  | 'wrench'
  | 'landmark'
  | 'square-user'
  | 'slack'
  | 'sliders-horizontal'
  | 'infinity'
  | 'megaphone'
  | 'id-card'
  | 'camera'
  | 'award'
  | 'wand-sparkles'
  | 'zap'
  | 'bookmark'
  | 'paintbrush'
  | 'bug'
  | 'briefcase-business'
  | 'cake'
  | 'volume-2'
  | 'gamepad-2'
  | 'party-popper'
  | 'armchair'
  | 'minimize-2'
  | 'construction'
  | 'clipboard-paste'
  | 'phone_iphone'
  | 'smartphone'
  | 'pencil-line'
  | 'leaf'
  | 'siren'
  | 'trophy'
  | 'chart-no-axes-column'
  | 'compass'
  | 'heart'
  | 'plane-takeoff'
  | 'hand'
  | 'sigma'
  | 'grid-3x3'
  | 'headphones'
  | 'heart-handshake'
  | 'file-down'
  | 'keyboard'
  | 'languages'
  | 'laptop'
  | 'chart-bar-stacked'
  | 'chart-gantt'
  | 'library'
  | 'wine'
  | 'beer'
  | 'flame'
  | 'flower-2'
  | 'film'
  | 'clapperboard'
  | 'pizza'
  | 'shield'
  | 'shield-user'
  | 'printer'
  | 'truck'
  | 'sandwich'
  | 'recycle'
  | 'scan-eye'
  | 'scan-search'
  | 'flask-conical'
  | 'store'
  | 'theater'
  | 'thumbs-up'
  | 'toggle-right'
  | 'trending-up'
  | 'pin-off'
  | 'pin'
  | 'panel-right'
  | 'panel-right-dashed'
  | 'ruler-dimension-line'
  | 'hand-heart'
  | 'droplets'
  | 'webhook'
  | 'sofa'
  | 'dices'
  | 'map-pin'
  | 'shield-check'
  | 'chart-no-axes-combined'
  | 'circle-off'
  | 'link-2-off'
  | 'banknote-x'
  | 'user-minus'
  | 'archive-restore'
  | 'calendar-check'
  | 'maximize'
  | 'hourglass'
  | 'a-large-small'
  | 'chevrons-right'
  | 'skip-forward'
  | 'fast-forward'
  | 'music'
  | 'navigation'
  | 'picture-in-picture-2'
  | 'power'
  | 'mic'
  | 'mouse-pointer-click'
  | 'move-right'
  | 'square-plus'
  | 'mail-warning'
  | 'bell-filled-alt'
  | 'bell-ring-filled'
  | 'billed'
  | 'calendar-schedule'
  | 'connect'
  | 'done-show'
  | 'download-pdf'
  | 'download-spreadsheet'
  | 'file-export'
  | 'flag-filled'
  | 'flag-filled-alt'
  | 'heart-filled'
  | 'menu-mini'
  | 'menu-open'
  | 'not-billed'
  | 'pause-filled'
  | 'play-filled'
  | 'popout'
  | 'popout-center'
  | 'sso'
  | 'credit-card'
  | 'wifi-off'
  | 'star-filled'
  | 'star-filled-alt'
  | 'stop-filled'
  | 'sheet'
  | 'table-export'
  | 'text-cursor-input'
  | 'square-arrow-right-enter'
  | 'file-mic'

export const icons: Partial<Record<Icon | LucideIcon, IconNode>> = {
  '1d': Timer,
  '1h': Timer,
  'a-arrow-down': AArrowDown,
  'a-large-small': ALargeSmall,
  access_alarm: AlarmClock,
  access_time: Clock9,
  account_balance: Landmark,
  account_box: SquareUser,
  account_circle: UserLock,
  account_tree: Network,
  add: Plus,
  add_a_photo: ImagePlus,
  add_circle_outline: CirclePlus,
  add_reaction: SmilePlus,
  adjust: SlidersHorizontal,
  admin_panel_settings: ShieldCheck,
  agent: AiAgent,
  ai: Sparkles,
  ai_popup: PopoutCenter,
  ai_sidebar: Popout,
  airplanemode_active: Plane,
  alarm: AlarmClock,
  'alarm-clock': AlarmClock,
  all_inclusive: InfinityIcon,
  alternate_email: AtSign,
  announcement: Megaphone,
  apartment: Building,
  apps: LayoutGrid,
  astroid: Astroid,
  archive: Archive,
  'archive-restore': ArchiveRestore,
  armchair: Armchair,
  'arrow-down': ArrowDown,
  'arrow-down-narrow-wide': ArrowDownNarrowWide,
  'arrow-down-to-line': ArrowDownToLine,
  'arrow-down-wide-narrow': ArrowDownWideNarrow,
  'arrow-down-z-a': ArrowDownZA,
  'arrow-left': ArrowLeft,
  'arrow-left-right': ArrowLeftRight,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  'arrow-up-0-1': ArrowUp01,
  'arrow-up-a-z': ArrowUpAZ,
  'arrow-up-down': ArrowUpDown,
  'arrow-up-narrow-wide': ArrowUpNarrowWide,
  'arrow-up-wide-narrow': ArrowUpWideNarrow,
  'arrow-up-z-a': ArrowUpZA,
  arrow_back: ArrowLeft,
  arrow_circle_right: CircleArrowRight,
  arrow_downward: ArrowDown,
  arrow_forward: ArrowRight,
  arrow_forward_ios: ChevronRight,
  arrow_upward: ArrowUp,
  article: FileText,
  assessment: ChartNoAxesCombined,
  assignment_ind: IdCard,
  assistant: WandSparkles,
  assistant_photo: WandSparkles,
  'at-sign': AtSign,
  attach_file: Paperclip,
  attach_money: Receipt,
  auto_awesome: WandSparkles,
  auto_fix_high: WandSparkles,
  autorenew: RefreshCw,
  award: Award,
  awork: AworkBot,
  awork_connect: Connect,
  'bell-filled-alt': BellFilledAlt,
  'bell-ring-filled': BellRingFilled,
  billed: Billed,
  'calendar-schedule': CalendarSchedule,
  connect: Connect,
  'done-show': DoneShow,
  'download-pdf': DownloadPdf,
  'download-spreadsheet': DownloadSpreadsheet,
  file_upload: Upload,
  'file-export': FileExport,
  'flag-filled': FlagFilled,
  'flag-filled-alt': FlagFilledAlt,
  'heart-filled': HeartFilled,
  'menu-mini': MenuMini,
  'menu-open': MenuOpen,
  'not-billed': NotBilled,
  'pause-filled': PauseFilled,
  'play-filled': PlayFilled,
  popout: Popout,
  'popout-center': PopoutCenter,
  sso: Sso,
  'star-filled': StarFilled,
  'star-filled-alt': StarFilledAlt,
  'stop-filled': StopFilled,
  'table-export': TableExport,
  'file-mic': FileMic,
  back_hand: Hand,
  ban: Ban,
  banknote: Banknote,
  'banknote-x': BanknoteX,
  bar_chart: ChartBar,
  baseline: Baseline,
  bedtime: Moon,
  beer: Beer,
  bell: Bell,
  'bell-off': BellOff,
  'bell-ring': BellRing,
  block: Ban,
  blocks: Blocks,
  bold: Bold,
  bolt: Zap,
  'book-open': BookOpen,
  'book-open-text': BookOpenText,
  bookmark: Bookmark,
  brain: Brain,
  'brain-cog': BrainCog,
  bot: Bot,
  briefcase: Briefcase,
  'briefcase-business': BriefcaseBusiness,
  brush: Paintbrush,
  bubble_chart: ChartNoAxesColumn,
  bug: Bug,
  bug_report: Bug,
  build: Wrench,
  building: Building,
  'building-2': Building2,
  bundle: SwatchBook,
  business: Building2,
  business_center: BriefcaseBusiness,
  cached: RefreshCw,
  cake: Cake,
  calculate: Calculator,
  calculator: Calculator,
  calendar: Calendar,
  'calendar-arrow-down': CalendarArrowDown,
  'calendar-arrow-up': CalendarArrowUp,
  'calendar-check': CalendarCheck,
  'calendar-clock': CalendarClock,
  'calendar-cog': CalendarCog,
  'calendar-1': Calendar1,
  'calendar-days': CalendarDays,
  'calendar-fold': CalendarFold,
  'calendar-plus': CalendarPlus,
  'clock-plus': ClockPlus,
  'calendar-x': CalendarX,
  calendar_today: CalendarFold,
  call: Phone,
  camera: Camera,
  camera_alt: Camera,
  campaign: Megaphone,
  cancel: CircleX,
  casino: Dices,
  category: PencilRuler,
  celebration: PartyPopper,
  chair: Armchair,
  'chart-bar': ChartBar,
  'chart-bar-big': ChartBarBig,
  'chart-bar-stacked': ChartBarStacked,
  'chart-gantt': ChartGantt,
  'chart-column': ChartColumn,
  'chart-line': ChartLine,
  'chart-no-axes-column': ChartNoAxesColumn,
  'chart-no-axes-combined': ChartNoAxesCombined,
  chat: MessageSquare,
  chat_bubble_outline: MessageCircle,
  chat_bubble_outline_2: MessageCircle,
  check: Check,
  'check-check': CheckCheck,
  check_box: SquareCheckBig,
  check_circle: CircleCheck,
  check_circle_outline: CircleCheck,
  checklist: ListChecks,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'chevrons-down': ChevronsDown,
  'chevrons-up-down': ChevronsUpDown,
  chevron_left: ChevronLeft,
  chevron_right: ChevronRight,
  'chevrons-right': ChevronsRight,
  circle: Circle,
  'circle-alert': CircleAlert,
  'circle-arrow-right': CircleArrowRight,
  'badge-check': BadgeCheck,
  'circle-check': CircleCheck,
  'circle-help': CircleHelp,
  'circle-minus': CircleMinus,
  'circle-off': CircleOff,
  'circle-play': CirclePlay,
  'circle-plus': CirclePlus,
  'circle-x': CircleX,
  'circle-stop': CircleStop,
  circle_with_color: Circle,
  circle_without_color: Circle,
  clapperboard: Clapperboard,
  class: GraduationCap,
  clear: X,
  'clipboard-check': ClipboardCheck,
  'clipboard-list': ClipboardList,
  'clipboard-paste': ClipboardPaste,
  clock: Clock,
  'clock-3': Clock3,
  'clock-9': Clock9,
  close: X,
  close_fullscreen: Minimize2,
  cloud: Cloud,
  'cloud-download': CloudDownload,
  cloud_download: CloudDownload,
  cog: Cog,
  code: Code,
  code_block: SquareCode,
  coffee: Coffee,
  color_lens: Palette,
  'columns-3': Columns3,
  comment: MessageSquareText,
  compact: LayoutGrid,
  compass: Compass,
  computer: Monitor,
  construction: Construction,
  'contact-round': ContactRound,
  content_copy: CopyPlus,
  content_paste: ClipboardPaste,
  control_point: CirclePlus,
  copy: Copy,
  'copy-markdown': CopyMarkdown,
  'copy-check': CopyCheck,
  'copy-plus': CopyPlus,
  'corner-down-left': CornerDownLeft,
  'corner-down-right': CornerDownRight,
  'credit-card': CreditCard,
  coronavirus: Bug,
  create_new_folder: FolderPlus,
  dark_mode: Moon,
  dashboard: LayoutDashboard,
  database: Database,
  date_range: CalendarDays,
  date_subtasks: CalendarCheck,
  delete: Trash2,
  delete_outline: Trash2,
  dependency: GitCompareArrows,
  description: FileText,
  desktop_mac: Monitor,
  devices: Smartphone,
  dices: Dices,
  do_disturb: CircleOff,
  domain: Building2,
  domain_disabled: Building2,
  done: Check,
  done_all: CheckCheck,
  done_tripple_all: CheckCheck,
  download: Download,
  drafts: MailOpen,
  drag_handle: GripVertical,
  draw: PencilLine,
  drive_file_move: FolderInput,
  droplets: Droplets,
  dvr: Files,
  eco: Leaf,
  edit: Pencil,
  ellipsis: Ellipsis,
  'ellipsis-vertical': EllipsisVertical,
  email: Mail,
  emergency: Siren,
  emoji_emotions: SmilePlus,
  emoji_events: PartyPopper,
  emoji_people: SmilePlus,
  equalizer: ChartNoAxesColumn,
  error: CircleAlert,
  error_outline: CircleAlert,
  euro: Tag,
  event: Calendar,
  event_available: CalendarCheck,
  event_busy: CalendarX,
  event_new: CalendarPlus,
  event_upcoming: CalendarClock,
  expand_less: ChevronUp,
  expand_more: ChevronDown,
  explore: Compass,
  export_pdf: DownloadPdf,
  extension: Blocks,
  'external-link': ExternalLink,
  eye: Eye,
  'eye-off': EyeOff,
  face: Camera,
  factory: Factory,
  favorite: Heart,
  feed: Rss,
  'file-clock': FileClock,
  'file-down': FileDown,
  'file-image': FileImage,
  'file-input': FileInput,
  'file-import-markdown': FileImportMarkdown,
  'file-output': FileOutput,
  'file-text': FileText,
  file_copy: Copy,
  file_download: Download,
  files: Files,
  film: Film,
  filter: Filter,
  filter_alt: Filter,
  fingerprint: Fingerprint,
  flag: Flag,
  goal: Goal,
  flame: Flame,
  'flask-conical': FlaskConical,
  flight: Plane,
  flight_takeoff: PlaneTakeoff,
  'flower-2': Flower2,
  folder: Folder,
  'folder-check': FolderCheck,
  'folder-heart': FolderHeart,
  'folder-input': FolderInput,
  'folder-kanban': FolderKanban,
  kanban: Kanban,
  'square-kanban': SquareKanban,
  'folder-open': FolderOpen,
  'folder-plus': FolderPlus,
  folder_open: Folder,
  folder_shared: FolderHeart,
  folder_special: FolderHeart,
  font_download: Type,
  format_align_left: TextAlignStart,
  format_bold: Bold,
  format_h1: Heading1,
  format_h2: Heading2,
  format_h3: Heading3,
  format_italic: Italic,
  format_link: Link,
  format_list_bullet: List,
  format_list_bulleted: List,
  format_list_numbered: ListOrdered,
  format_paint: PaintRoller,
  format_quote: Quote,
  format_size: ALargeSmall,
  format_underlined: Underline,
  form: FormInput,
  forum: MessagesSquare,
  front_hand: Hand,
  fullscreen: Maximize,
  fullwidth: ScanEye,
  functions: Sigma,
  'gamepad-2': Gamepad2,
  gesture: PencilLine,
  get_app: Download,
  gif: Image,
  gift: Gift,
  'git-compare-arrows': GitCompareArrows,
  globe: Globe,
  golf_course: Flag,
  grade: Heart,
  'graduation-cap': GraduationCap,
  'grid-3x3': Grid3x3,
  grid_on: Grid3x3,
  'grip-horizontal': GripHorizontal,
  'grip-vertical': GripVertical,
  group: UsersRound,
  group_add: UserPlus,
  group_off: UserX,
  groups: Users,
  hand: Hand,
  'hand-heart': HandHeart,
  hash: Hash,
  handshake: Handshake,
  'heading-1': Heading1,
  'heading-2': Heading2,
  'heading-3': Heading3,
  headset: Headset,
  headphones: Headphones,
  healing: HeartHandshake,
  heart: Heart,
  'heart-handshake': HeartHandshake,
  'heart-pulse': HeartPulse,
  help_outline: CircleHelp,
  history: History,
  home: House,
  hourglass: Hourglass,
  hourglass_bottom: Hourglass,
  hourglass_empty: Hourglass,
  house: House,
  'id-card': IdCard,
  image: Image,
  'image-down': ImageDown,
  'image-plus': ImagePlus,
  import_docs: FileInput,
  inbox: Inbox,
  infinity: InfinityIcon,
  info: Info,
  info_outline: Info,
  input: LogIn,
  insert_chart_outlined: ChartColumn,
  insert_drive_file: FileDown,
  insert_invitation: CalendarPlus,
  insert_link: Link,
  insights: Lightbulb,
  italic: Italic,
  'key-round': KeyRound,
  keyboard: Keyboard,
  keyboard_arrow_down: ChevronDown,
  keyboard_arrow_left: ChevronLeft,
  keyboard_arrow_right: ChevronRight,
  keyboard_arrow_up: ChevronUp,
  keyboard_tab: GitCompareArrows,
  label: Tag,
  landmark: Landmark,
  language: Languages,
  languages: Languages,
  laptop: Laptop,
  launch: ExternalLink,
  layers: Layers,
  'layout-dashboard': LayoutDashboard,
  'layout-grid': LayoutGrid,
  'layout-list': LayoutList,
  'layout-template': LayoutTemplate,
  leaderboard: ChartBarStacked,
  leaf: Leaf,
  library: Library,
  library_books: Library,
  'life-buoy': LifeBuoy,
  light_mode: Sun,
  lightbulb: Lightbulb,
  lightbulb_outline: Lightbulb,
  link: Link,
  'link-2-off': Link2Off,
  link_off: Link2Off,
  liquor: Wine,
  list: ListTodo,
  'list-checks': ListChecks,
  'list-ordered': ListOrdered,
  'list-todo': ListTodo,
  'list-tree': ListTree,
  live_help: CircleHelp,
  local_airport: Plane,
  local_bar: Beer,
  local_cafe: Coffee,
  local_fire_department: Flame,
  local_florist: Flower2,
  local_grocery_store: ShoppingCart,
  local_movies: Film,
  local_offer: Tag,
  local_pizza: Pizza,
  local_police: Shield,
  local_print_shop: Printer,
  local_shipping: Truck,
  location_city: Building,
  location_on: MapPin,
  lock: Lock,
  'lock-keyhole': LockKeyhole,
  'lock-keyhole-open': LockKeyholeOpen,
  lock_open: LockKeyholeOpen,
  lock_outline: LockKeyhole,
  loader: Loader,
  'log-in': LogIn,
  'log-out': LogOut,
  loop: RefreshCw,
  lunch_dining: Sandwich,
  mail: Mail,
  'mail-open': MailOpen,
  'mail-warning': MailWarning,
  map: Map,
  'map-pin': MapPin,
  maximize: Maximize,
  'maximize-2': Maximize2,
  megaphone: Megaphone,
  menu: Menu,
  menu_2: Menu,
  menu_book: BookOpen,
  message: MessageSquare,
  'message-circle': MessageCircle,
  'message-circle-more': MessageCircleMore,
  'message-square': MessageSquare,
  'message-square-quote': MessageSquareQuote,
  'message-square-text': MessageSquareText,
  'messages-square': MessagesSquare,
  messenger: MessageSquare,
  messenger_outline: MessageSquare,
  mic: Mic,
  milestone: Milestone,
  military_tech: Trophy,
  'minimize-2': Minimize2,
  minus: Minus,
  miscellaneous_services: Settings,
  mode: Pencil,
  mode_edit: Pencil,
  money_off: BanknoteX,
  monitor: Monitor,
  'monitor-cog': MonitorCog,
  'monitor-play': MonitorPlay,
  mood: Smile,
  moon: Moon,
  more_vert: EllipsisVertical,
  movie: Clapperboard,
  movie_creation: Clapperboard,
  multi_select: SquareCheckBig,
  'mouse-pointer-click': MousePointerClick,
  'move-right': MoveRight,
  music: Music,
  music_note: Music,
  navigation: NavigationIcon,
  network: Network,
  newspaper: Newspaper,
  not_interested: Ban,
  not_set_warning: TriangleAlert,
  note: StickyNote,
  'notebook-text': NotebookText,
  notes: StickyNote,
  notifications: BellRingFilled,
  notifications_none: Bell,
  notifications_off: BellOff,
  now_widgets: LayoutGrid,
  open_in_full: Maximize2,
  open_in_new: ExternalLink,
  origami: Origami,
  outlined_flag: Flag,
  'paint-roller': PaintRoller,
  paintbrush: Paintbrush,
  palette: Palette,
  'panel-left-close': PanelLeftClose,
  'panel-left-open': PanelLeftOpen,
  'panel-right': PanelRight,
  'panel-right-dashed': PanelRightDashed,
  'panel-right-close': PanelRightClose,
  'panel-right-open': PanelRightOpen,
  'panels-right-bottom': PanelsRightBottom,
  'panels-top-left': PanelsTopLeft,
  paperclip: Paperclip,
  'party-popper': PartyPopper,
  pause: Pause,
  pause_circle_outline: Coffee,
  'paw-print': PawPrint,
  'pen-tool': PenTool,
  pencil: Pencil,
  'pencil-line': PencilLine,
  'pencil-ruler': PencilRuler,
  people: UsersRound,
  people_alt: Users,
  perm_contact_calendar: ContactRound,
  person: UserRound,
  person_add: UserPlus,
  person_icon: UserX,
  person_off: UserX,
  person_remove: UserMinus,
  person_search: UserSearch,
  pets: PawPrint,
  phone: Phone,
  photo: Image,
  photo_camera: Camera,
  'picture-in-picture-2': PictureInPicture2,
  picture_in_picture_alt: PictureInPicture2,
  'pie-chart': PieChart,
  pie_chart: PieChart,
  pie_chart_outline: PieChart,
  'piggy-bank': PiggyBank,
  pin: Pin,
  'pin-off': PinOff,
  pizza: Pizza,
  place: MapPin,
  plan_backward: CalendarArrowDown,
  plan_forward: CalendarArrowUp,
  plan_out: CalendarClock,
  plane: Plane,
  'plane-takeoff': PlaneTakeoff,
  planned: PlannedEffort,
  play: Play,
  play_arrow: Play,
  play_circle_outline: CirclePlay,
  playlist_add_check: ListChecks,
  plus: Plus,
  pointer: Pointer,
  poll: ChartNoAxesColumn,
  portrait: User,
  power: Power,
  presentation: Presentation,
  print: Printer,
  printer: Printer,
  priority_high: CircleAlert,
  progress_budget: PiggyBank,
  progress_tasks: ListChecks,
  progress_time: CalendarClock,
  project: FolderKanban,
  public: Globe,
  push_pin: Pin,
  puzzle: Puzzle,
  question_answer: MessageSquare,
  quote: Quote,
  radio_button_unchecked: Circle,
  receipt: Receipt,
  receipt_long: Receipt,
  recycle: Recycle,
  recycling: Recycle,
  redeem: Gift,
  refresh: RefreshCw,
  'refresh-cw': RefreshCw,
  remove: Minus,
  remove_circle_outline: CircleMinus,
  remove_column: RemoveColumn,
  remove_red_eye: Eye,
  remove_row: RemoveRow,
  reorder: GripHorizontal,
  repeat: Repeat,
  replay: RotateCcw,
  report_problem: TriangleAlert,
  restart_alt: RotateCcw,
  restaurant: Utensils,
  review: RotateCcw,
  rocket_launch: Rocket,
  'rotate-ccw': RotateCcw,
  route: Route,
  'ruler-dimension-line': RulerDimensionLine,
  rss: Rss,
  sandwich: Sandwich,
  save: Save,
  scale: Scale,
  'scan-eye': ScanEye,
  'scan-search': ScanSearch,
  schedule: Clock,
  school: GraduationCap,
  scroll: Scroll,
  science: FlaskConical,
  scroll_into_view: ArrowDownToLine,
  search: Search,
  sell: Tag,
  send: Send,
  sentiment_satisfied_alt: Smile,
  settings: Settings,
  'settings-2': Settings2,
  seven_days: CalendarDays,
  share: Share,
  sheet: Sheet,
  shield: Shield,
  'shield-user': ShieldUser,
  'shield-check': ShieldCheck,
  'shopping-bag': ShoppingBag,
  'shopping-cart': ShoppingCart,
  shopping_cart: ShoppingCart,
  short_text: NotebookText,
  show_chart: ChartLine,
  signal: Signal,
  'signal-high': SignalHigh,
  'signal-low': SignalLow,
  'signal-medium': SignalMedium,
  'signal-zero': SignalZero,
  sigma: Sigma,
  siren: Siren,
  'skip-forward': SkipForward,
  'fast-forward': FastForward,
  skip_next: SkipForward,
  slack: Slack,
  'sliders-horizontal': SlidersHorizontal,
  slideshow: Presentation,
  slow_motion_video: Video,
  smart_button: ToggleLeft,
  smart_display: MonitorPlay,
  phone_iphone: Smartphone,
  smartphone: Smartphone,
  smile: Smile,
  'smile-plus': SmilePlus,
  sofa: Sofa,
  sort: ArrowUpDown,
  sort_ascending: ArrowUpNarrowWide,
  sort_by_alpha: ArrowUpAZ,
  sort_descending: ArrowDownWideNarrow,
  sparkle: Sparkle,
  sparkles: Sparkles,
  'spell-check': SpellCheck,
  spell_check: SpellCheck,
  spellcheck: SpellCheck,
  sports_esports: Gamepad2,
  sports_soccer: Circle,
  square: Square,
  'square-check': SquareCheck,
  'square-check-big': SquareCheckBig,
  'square-code': SquareCode,
  'square-minus': SquareMinus,
  'square-plus': SquarePlus,
  'square-user': SquareUser,
  square_foot: SwatchBook,
  star: Star,
  star_border: StarFilled,
  star_outline: StarFilled,
  stars: Sparkles,
  'sticky-note': StickyNote,
  stop: Square,
  storage: Database,
  store: Store,
  strikethrough: Strikethrough,
  strikethrough_s: Strikethrough,
  style: Paintbrush,
  subdirectory_arrow_left: CornerDownLeft,
  subdirectory_arrow_right: CornerDownRight,
  subtask: ListTree,
  subtasks: ListTree,
  summarize: FileText,
  sun: Sun,
  supervisor_account: Users,
  support: LifeBuoy,
  swap_horiz: ArrowLeftRight,
  'swatch-book': SwatchBook,
  sync: RefreshCw,
  table: Table,
  'table-of-contents': TableOfContents,
  table_outline: Table,
  table_view: Table,
  tag: Tag,
  'tally-5': Tally5,
  task: SquareCheck,
  task_alt: CircleCheck,
  'text-align-start': TextAlignStart,
  'text-wrap': TextWrap,
  text_color: Baseline,
  text_fields: Type,
  text_format: Type,
  text_snippet: FileText,
  theater: Theater,
  theaters: Theater,
  thumb_up: ThumbsUp,
  'thumbs-up': ThumbsUp,
  tv: Tv,
  time_booking: Clock,
  timelapse: Budget,
  timeline: ChartBarBig,
  timer: Timer,
  timer_all: Timer,
  toc: TableOfContents,
  today: CalendarFold,
  'toggle-left': ToggleLeft,
  'toggle-right': ToggleRight,
  toggle_on: ToggleRight,
  touch_app: Pointer,
  'trash-2': Trash2,
  trello: Trello,
  'trending-up': TrendingUp,
  trending_up: TrendingUp,
  'triangle-alert': TriangleAlert,
  trophy: Trophy,
  truck: Truck,
  tune: Settings2,
  type: Type,
  unarchive: ArchiveRestore,
  underline: Underline,
  undo: Undo2,
  redo: Redo2,
  'undo-2': Undo2,
  unpin: PinOff,
  update: RefreshCw,
  upload: Upload,
  user: User,
  'user-lock': UserLock,
  'user-minus': UserMinus,
  'user-plus': UserPlus,
  'user-round': UserRound,
  'user-round-plus': UserRoundPlus,
  'user-search': UserSearch,
  'user-x': UserX,
  users: Users,
  'users-round': UsersRound,
  utensils: Utensils,
  version_history: History,
  video: Video,
  view_agenda: LayoutList,
  view_compact: PanelsRightBottom,
  view_column: Columns3,
  view_headline: TextAlignStart,
  view_list: LayoutList,
  view_module: LayoutGrid,
  view_sidebar: PanelRight,
  visibility: Eye,
  visibility_off: EyeOff,
  visibility_on: Eye,
  'volume-2': Volume2,
  volume_up: Volume2,
  volunteer_activism: HandHeart,
  vpn_key: KeyRound,
  'wand-sparkles': WandSparkles,
  warning: TriangleAlert,
  'wifi-off': WifiOff,
  watch: Watch,
  watch_later: Clock,
  water: Droplets,
  water_drop: Droplets,
  wb_sunny: Sun,
  wc: Award,
  web: Globe,
  web_asset: Globe,
  webhook: Webhook,
  weekend: Sofa,
  whatshot: Flame,
  wine: Wine,
  work: Briefcase,
  workload: Watch,
  wrench: Wrench,
  x: X,
  zap: Zap,
  'zoom-in': ZoomIn,
  'zoom-out': ZoomOut,
  zoom_in: ZoomIn,
  zoom_out: ZoomOut,
  zoom_out_map: Maximize2,
  'text-cursor-input': TextCursorInput,
  'square-arrow-right-enter': SquareArrowRightEnter
}
